import React, { useState, useEffect } from 'react'
import { HeaderDiv1, DescrDiv } from '../styles/div';
export default function Career(props) {
    useEffect(() => {
        props.click('career');
      }, [])
    return (<div style={{textAlign: "left", overflowY: "scroll", padding: "2rem", marginTop: "4rem"}}>


    <div style={{padding: "1rem"}}>
    <DescrDiv>Please get in touch at <a style={{textDecoration: "underline"}} href="mailto:info@cogitarelabs.com?subject=Apply&body=Hi Team">info@cogitarelabs.com</a></DescrDiv>
    </div>

    <div style={{padding: "1rem"}}>
    <HeaderDiv1>Passionate about Mind Upload</HeaderDiv1>
    <DescrDiv>
        <ol>If you are finding ways on how you can achieve this, then Cogitare Labs is the right place for you</ol>
    </DescrDiv>
    </div>
   

</div>)
}
